export default "__VITE_ASSET__Bb9Xfp4d__"